<template>
  <div>
    <div v-if="!loading" v-html="html"></div>
    <shark-loader v-else></shark-loader>
  </div>
</template>

<script>
export default {
  name: 'PaypalButton',
  props: ["loading", "html"]
}
</script>